<div class="chart-wrapper">
    <canvas id="canvas"></canvas>
</div>